import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import * as Swiper from 'swiper/dist/js/swiper.js';
import '../../interfaces/slider.interface';
import './add-on-get-app-qrcode-slider.component.scss';
var AddOnGetAppQrcodeSlider = /** @class */ (function (_super) {
    tslib_1.__extends(AddOnGetAppQrcodeSlider, _super);
    function AddOnGetAppQrcodeSlider(element) {
        return _super.call(this, element) || this;
    }
    AddOnGetAppQrcodeSlider.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.windowWidth = document.documentElement.clientWidth;
        this.breakpoints = {};
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            breakpoints: this.breakpoints,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        this.sliderComponent = new Swiper(this.sliderContainer, this.sliderConfig);
    };
    AddOnGetAppQrcodeSlider.prototype.bindEvents = function () {
    };
    return AddOnGetAppQrcodeSlider;
}(Base));
export { AddOnGetAppQrcodeSlider };



//////////////////
// WEBPACK FOOTER
// ./components/add-on-get-app-qrcode-slider/add-on-get-app-qrcode-slider.component.ts
// module id = 608
// module chunks = 0